import { render, staticRenderFns } from "./ShortcodeList.vue?vue&type=template&id=c5d300f2&scoped=true&"
import script from "./ShortcodeList.vue?vue&type=script&lang=js&"
export * from "./ShortcodeList.vue?vue&type=script&lang=js&"
import style0 from "./ShortcodeList.vue?vue&type=style&index=0&id=c5d300f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d300f2",
  null
  
)

export default component.exports